import { CommonMutationCrumbs } from './breadcrumb';

export const SearchPersonCivilUnionNonResidentCrumbs = [
  ...CommonMutationCrumbs,
  {
    name: 'Ricerca persona - Registrazione Unione Civile Non Residenti',
    path: '/mutazioni/persona/unione-civile/non-residenti',
  },
];

export const RegistrationCivilUnionNonResidentCrumbs = [
  ...SearchPersonCivilUnionNonResidentCrumbs,
  {
    name: 'Registrazione Unione Civile Non Residenti',
    path: '/mutazioni/persona/unione-civile/non-residenti/registrazione/:idIntestatario/:idSchedaSoggettoANPR',
  },
];
